import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import CreateCommercialInvoice from "./documents/commercialInvoice/create";
import Reports from "./reports";
import ExportData from "./ExportData";
import ShipmentDetail from "./detail";
import ShipmentList from "./list";
import SplitShipment from "./detail/Split";
import PackingListPreview from "./documents/packingList/Preview";
import CommercialInvoicePreview from "./documents/commercialInvoice/preview";
import CustomFormView from "./documents/customForm/Create";
import CustomFormPreview from "./documents/customForm/Preview";
import Page from "components/base/Page";
import { NavigationLink } from "components/base/base";

function ShipmentRoutes() {
  return (
    <Routes>
      <Route
        element={
          <Page
            leftButtons={
              <div className="flex space-x-4">
                <NavigationLink to="/shipment/shipments" title="Shipments" />
              </div>
            }
            rightButtons={
              <div className="flex space-x-4">
                <NavigationLink to="/shipment/reports" title="Reports" />
                <NavigationLink to="/shipment/export" title="Export" />
              </div>
            }
          >
            <Outlet />
          </Page>
        }
      >
        <Route path="shipments" element={<ShipmentList />} />

        <Route path="reports" element={<Reports />} />
        <Route path="export" element={<ExportData />} />

        <Route path="*" element={<Navigate to="shipments" />} />
      </Route>

      <Route path="shipments/:id" element={<ShipmentDetail />} />

      <Route path="shipments/:id/split" element={<SplitShipment />} />

      <Route path="doc">
        <Route
          path="packing-list/:id/preview"
          element={<PackingListPreview />}
        />

        <Route
          path="commercial-invoice/:id"
          element={<CreateCommercialInvoice />}
        />
        <Route
          path="commercial-invoice/:id/preview"
          element={<CommercialInvoicePreview />}
        />

        <Route path="custom-form/:id" element={<CustomFormView />} />
        <Route path="custom-form/:id/preview" element={<CustomFormPreview />} />
      </Route>
    </Routes>
  );
}

export default ShipmentRoutes;
